(() => {
  // Exact hosts prevent lookalike domains from being treated as YouTube links.
  const youtubeHosts = new Set([
    'youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com'
  ]);
  const embedHosts = new Set(['youtube-nocookie.com', 'www.youtube-nocookie.com']);
  const shortHosts = new Set(['youtu.be', 'www.youtu.be']);

  function videoIdFromUrl(value, depth = 0) {
    try {
      const input = value.trim();
      const url = new URL(input.startsWith('//') ? `https:${input}` : input);
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.port) return null;

      const host = url.hostname.toLowerCase();
      const path = url.pathname;
      let id;

      if (shortHosts.has(host)) {
        id = path.match(/^\/([A-Za-z0-9_-]{11})\/?$/)?.[1];
      } else if (youtubeHosts.has(host) || embedHosts.has(host)) {
        if (youtubeHosts.has(host) && /^\/watch\/?$/.test(path)) {
          id = url.searchParams.get('v');
        } else if (youtubeHosts.has(host) && path === '/attribution_link' && depth === 0) {
          const target = url.searchParams.get('u');
          return target ? videoIdFromUrl(new URL(target, 'https://www.youtube.com').href, depth + 1) : null;
        } else {
          const formats = embedHosts.has(host) ? /^\/embed\/([A-Za-z0-9_-]{11})\/?$/ : /^\/(?:embed|shorts|live|v|e)\/([A-Za-z0-9_-]{11})\/?$/;
          id = path.match(formats)?.[1];
        }
      }

      // "videoseries" is the playlist embed route, not an individual video ID.
      return id !== 'videoseries' && /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : null;
    } catch {
      return null;
    }
  }

  if (customElements.get('product-youtube-videos')) return;

  customElements.define('product-youtube-videos', class extends HTMLElement {
    connectedCallback() {
      // Upgrades existing markup and new sections inserted by the theme editor.
      this.querySelectorAll('template[data-youtube-url]').forEach((template) => {
        const id = videoIdFromUrl(template.dataset.youtubeUrl);
        if (!id) {
          template.remove();
          return;
        }

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${id}`;
        iframe.title = template.dataset.videoTitle;
        iframe.width = '560';
        iframe.height = '315';
        iframe.loading = 'lazy';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        const wrapper = document.createElement('div');
        wrapper.className = 'product-youtube-videos__video';
        wrapper.appendChild(iframe);
        template.replaceWith(wrapper);
      });
      this.hidden = !this.querySelector('iframe');
    }
  });
})();
